import { setYupItalianValidationLocale } from '@framework/validation';
setYupItalianValidationLocale();
